import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface StatusDef {
  label: string;
  bg: string;
  text: string;
  group: string;
  description?: string;
}

@Injectable({ providedIn: 'root' })
export class StatusRegistryService {
  private statuses: Record<string, Record<string, StatusDef>> = {};
  private loaded = false;

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    if (this.loaded) return;
    try {
      const data = await firstValueFrom(
        this.http.get<Record<string, Record<string, StatusDef>>>('/assets/design-system/statuses.json')
      );
      // Strip metadata keys
      const { $schema, $description, ...domains } = data as any;
      this.statuses = domains;
      this.loaded = true;
    } catch (err) {
      console.warn('StatusRegistryService: Failed to load statuses.json', err);
      this.loaded = true;
    }
  }

  /**
   * Get status definition by domain and status key.
   * @param domain e.g. 'application', 'validity', 'membership'
   * @param status e.g. 'APPROVED', 'PENDING', 'VALID'
   */
  getStatus(domain: string, status: string): StatusDef | null {
    return this.statuses[domain]?.[status] ?? null;
  }

  /**
   * Get all statuses for a domain.
   */
  getStatusesByDomain(domain: string): Record<string, StatusDef> | null {
    return this.statuses[domain] ?? null;
  }
}
